import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link, withRouter, useHistory } from "react-router-dom";
// nodejs library that concatenates strings
import classnames from "classnames";
// reactstrap components
import {
  Button,
  Collapse,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  Modal,
  Input,
} from "reactstrap";
import Swal from 'sweetalert2';
import {
  getProducts,
  searchProducts,
} from "../../redux/actions/products_actions";
import {
  getTemplates,
  getCategoriesData,
} from "../../redux/actions/templates_actions";
import {
  initCart,
  setCartQuantity,
} from "../../redux/actions/cart_actions";
import Badge from '@material-ui/core/Badge';
import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';

const Header = ({...props}) => {
  const history = useHistory()

  const [navbarColor, setNavbarColor] = React.useState("navbar-transparent");
  const [navbarCollapse, setNavbarCollapse] = React.useState(false);

  const toggleNavbarCollapse = () => {
    setNavbarCollapse(!navbarCollapse);
    document.documentElement.classList.toggle ("nav-open");
    
  };

  const StyledBadge = withStyles((theme) => ({
    badge: {
      right: -1,
      top: 1,
      background: `red`,
    },
  }))(Badge);
  
  const [modal, setModal] = React.useState(false);
  const toggleModal = () => {
    setModal(!modal);
    //Hide Navigation 
    document.documentElement.classList.toggle("nav-open")
  };

  useEffect(() => {
    props.dispatch(getTemplates())
    props.dispatch(getCategoriesData())
    props.dispatch(setCartQuantity(props.cart.carts))  

    const updateNavbarColor = () => {
      if (
        document.documentElement.scrollTop > 299 ||
        document.body.scrollTop > 299
      ) {
        setNavbarColor("");
      } else if (
        document.documentElement.scrollTop < 300 ||
        document.body.scrollTop < 300
      ) {
        setNavbarColor("navbar-transparent");
      }
    };

    window.addEventListener("scroll", updateNavbarColor);

    return function cleanup() {
      window.removeEventListener("scroll", updateNavbarColor);
    };
  }, [props.cart.cartQuantity]);
  
  const renderCartQuantity = () => {
    //User Info
    let userInfo = JSON.parse(localStorage.getItem("user"))
    if(userInfo && props.cart) {
      if(window.innerWidth <= 760) {
        return(
          <NavLink style={{color:"black", cursor:"pointer", margin: 0 }} onClick={()=>{ userNavigate("/cart") }}>
            <IconButton style={{ color: "black", padding: 0, marginRight: '10%' }} aria-label="cart">
              <StyledBadge badgeContent={props.cart.cartQuantity} color="secondary">
                <ShoppingCartIcon /> 
              </StyledBadge>
            </IconButton>
            Giỏ Hàng
          </NavLink>
        ) 
      }
      else {
        return(
            <NavLink style={{color:"black", cursor:"pointer", margin: '0px -20px' }} onClick={()=>{ userNavigate("/cart") }}>
              <IconButton style={{ color: "black" }} aria-label="cart">
                <StyledBadge badgeContent={props.cart.cartQuantity} color="secondary">
                  <ShoppingCartIcon /> 
                </StyledBadge>
              </IconButton>
            </NavLink>
        )
      }
    }
  }

  //Logout
  const handleThenLogout = () => {
    //User Info
    let userInfo = JSON.parse(localStorage.getItem("user"))
    if(userInfo) {
      Swal.fire({
        title: 'Đăng xuất',
        text: "Bạn sẽ không thể mua hàng và sẽ xóa rỗng giỏ hàng đã chọn",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#000000',
        confirmButtonText: 'Đăng xuất',
        cancelButtonColor: '#999897',
        cancelButtonText: 'Hủy'
      }).then((result) => {
        if (result.value) {
          Swal.fire({
            title: 'Đăng xuất thành công!',
            text: 'Trở về trang chủ',
            icon: 'success',
            confirmButtonText: 'Đóng',
            confirmButtonColor: '#000000',
          }).then((ok)=>{
            if(ok){
              //Scroll to top
              window.scrollTo(0, 0)
              if(window.location.pathname == "/home") {
                window.location.reload(false)
              }
              else {
                history.push("/home")
              }
              localStorage.removeItem('user')
              props.dispatch(initCart())
            }
        })   
        }
      })
    }   
  }

  // Login Status
  const loginStatus = () => {
    //User Info
    let userInfo = JSON.parse(localStorage.getItem("user"))
    if(userInfo) {
      return(
          <>
          <UncontrolledDropdown nav inNavbar>
            <DropdownToggle
              caret
              color="default"
              data-toggle="dropdown"
              href="#pablo"
              id="dropdownMenuButton"
              nav
              role="button"
              style={{color:"black"}}
            >
              <i className="fas fa-user-circle" style={{ right: 0 }}></i> {userInfo.customerName}
            </DropdownToggle>
            <DropdownMenu
              aria-labelledby="dropdownMenuButton"
              className="dropdown-default"
            >
              <Link onClick={()=>{ userNavigate("/profile") }} style={{ color:"black" }}>
                <DropdownItem>
                  <i className="fas fa-user-circle"></i> Thông tin tài khoản
                </DropdownItem>
              </Link>
              <Link onClick={()=>{ userNavigate("/wishlist")}} style={{ color:"cart" }}>
                <DropdownItem>
                  <i className="fas fa-eye"></i> Sản phẩm yêu thích
                </DropdownItem>
              </Link>
              <DropdownItem divider />
              <DropdownItem
                onClick={handleThenLogout}
              >
                <i className="fas fa-sign-out-alt"></i> Đăng xuất
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
          </>
      )
    }
    else {
      return(
        <NavItem>
          <NavLink onClick={() => userNavigate("/login")} style={{ color: 'black', cursor: "pointer" }}><i className="fas fa-user-circle"></i>Đăng Nhập</NavLink>
        </NavItem>
      )
    }
  }
  
  // Search Products
  const handleSearch = () => {
    let value = document.getElementById("searchValue").value
    if(value != ""){
      localStorage.setItem("searchValue", JSON.stringify(value))
      props.dispatch(searchProducts(1, value))
      history.push("/search")
      //Hide Navigation 
      toggleNavbarCollapse()
      toggleModal()
      //Scroll to top
      window.scrollTo(0, 0)
    }
  }

  // Navigation Page
  const navigationPage = (category) => {
    if(category != null){
      props.dispatch(getProducts(category))
      history.push(`/products/${category}`)
      //Hide Navigation 
      if(window.innerWidth <= 760) {
        toggleNavbarCollapse()
      };
      //Scroll to top
      window.scrollTo(0, 0)
    }
  }

  // Navigation Page
  const userNavigate = (route) => {
    if(route) {
      history.push(route)
      //Scroll to top
      window.scrollTo(0, 0)
      //Hide Navigation 
      if(window.innerWidth <= 760 && route != "/home") {
        toggleNavbarCollapse()
      };
    }
  }

  const renderCategoriesData = () => (
    props.templates.categoriesData.categories.length > 0 ?
    props.templates.categoriesData.categories.map((item, index) => (
      <NavItem>
        <NavLink style={{color:"black", cursor: "pointer"}} onClick={() => navigationPage(item.categoryName)}>{item.categoryName}</NavLink>
      </NavItem>
    )) : null
  )

  if(props.templates.templates && props.templates.categoriesData) {
    return (
      <>
      <Navbar className={classnames("fixed-top", navbarColor)} expand="lg"> 
        <Container>
          <div className="navbar-translate">
            <NavbarBrand
              data-placement="bottom"
              onClick={ () => {userNavigate("/home")} } 
              style={{color:"black", cursor: "pointer"}}
            >
              {props.templates.templates.templateProperties.store_name}
            </NavbarBrand>
            <button
              aria-expanded={navbarCollapse}
              className={classnames("navbar-toggler", {
                toggled: navbarCollapse,
              })}
              onClick={toggleNavbarCollapse}
            >
              <span className="navbar-toggler-bar bar1" />
              <span className="navbar-toggler-bar bar2" />
              <span className="navbar-toggler-bar bar3" />
            </button>
          </div>
          <Collapse
            className="justify-content-end"
            navbar
            isOpen={navbarCollapse}
          >
            <Nav navbar>
              {/* <NavItem>
                <NavLink style={{color:"black", cursor: "pointer"}} onClick={() => navigationPage("sofa")}>Sofa</NavLink>
              </NavItem>
              <NavItem>
                <NavLink style={{color:"black", cursor: "pointer"}} onClick={() => navigationPage("chair")}>Ghế</NavLink>
              </NavItem>
              <NavItem>
                <NavLink style={{color:"black", cursor: "pointer"}} onClick={() => navigationPage("table")}>Bàn</NavLink>
              </NavItem>
              <NavItem>
                <NavLink style={{color:"black", cursor: "pointer"}} onClick={() => navigationPage("bed")}>Giường</NavLink>
              </NavItem> */}
              {renderCategoriesData()}
              <NavItem>
                <NavLink style={{color:"black", cursor:"pointer" }} onClick={toggleModal}><i className="fas fa-search fa-1x" style={{ right: 0 }}></i> Tìm Kiếm</NavLink>
              </NavItem>
              <NavItem>
                {renderCartQuantity()}
              </NavItem>
              {loginStatus()}
            </Nav>
          </Collapse>
        </Container>
      </Navbar>
  
      {/* Modal */}
      <Modal isOpen={modal} toggle={toggleModal} dialogClassName="modalDialog">
        <div className="modal-header">
          <button
            aria-label="Close"
            className="close"
            type="button"
            onClick={toggleModal}
          >
            <span aria-hidden={true}>×</span>
          </button>
          <h5
            className="modal-title text-center"
            id="exampleModalLabel"
          >
            Tìm Kiếm
          </h5>
        </div>
        <div className="modal-body">
          <div className="row justify-content-center">
              <Input className="text-center" placeholder="Nội dung tìm kiếm..." type="text" id="searchValue" style={{ width:320, marginRight:10, outline:0, borderWidth:"0 0 2px", borderRadius:0 }} /> 
          </div>
        </div>
        <div className="modal-footer">
          <div className="left-side">
            <Button
              className="btn-link"
              color="default"
              type="button"
              onClick={toggleModal}
            >
              Đóng
            </Button>
          </div>
          <div className="divider" />
          <div className="right-side">
            <Button 
              className="btn-link" 
              type="button" 
              onClick={handleSearch}
            >
              Tìm
            </Button>
          </div>
        </div>
      </Modal>
      </>
    );
  }
  else {
    return(null)
  }    
}

const mapStateToProps = (state) => {
  return {
    products: state.products,
    cart: state.cart,
    templates: state.templates,
  };
};

export default connect(mapStateToProps)(Header);
